import React from 'react'
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import { changeProfile, logout } from '../../../actions/authActions';
import { Translate } from '../../../language';
import Button from '../../../utils/components/Button/Button';
import Logout from '../../../components/User/Logout';
import './NavbarMenu.css'
import localStorage from '../../../utils/hooks/useLocalStorage';

const NavbarMenu = ({
    setIsShowMenu = () => { },
    userInfo = {},
    isShowMenu,
}) => {
    const history = useHistory()
    const dispatch = useDispatch()
    return (
        <div className='scroll-menu content-navbar-menu'>
            <div>
                <div className="title-navbar-menu">Menú</div>
                <div onClick={() => {
                    setIsShowMenu(!isShowMenu)
                    history.push('/PersonalInfo')
                }} className="text-navbar-navbar">Información personal</div>
                <div onClick={() => {
                    setIsShowMenu(!isShowMenu)
                    history.push('/ResetPassword')
                }} className="text-navbar-navbar">Cambio de contraseña</div>
                <div onClick={(e) => {
                    setIsShowMenu(!isShowMenu)
                    history.push('/TermsAndConditions')
                }} className="text-navbar-navbar">Terminos y condiciones</div>
                {/*  <div onClick={() => {
                    setIsShowMenu(!isShowMenu)
                    history.push('/BlockedFriendList')
                }} className="text-navbar-navbar">Bloqueos</div>
                <div onClick={() => {
                    setIsShowMenu(!isShowMenu)
                    history.push('/Reports')
                }} className="text-navbar-navbar">Reportes</div> */}
                {
                    !userInfo.warehouseID && <>
                        {
                            !userInfo?.authRequestID ? <div onClick={() => {
                                setIsShowMenu(!isShowMenu)
                                history.push('/CertificateAccountData')
                            }} className="text-navbar-navbar">Verificar cuenta</div> :
                                <div>
                                    {userInfo?.authRequestID.state === 0 && <p>Pendiente de verificacion</p>}
                                    {userInfo?.authRequestID.state === 1 && <p>Verificacion Rechazada</p>}
                                    {userInfo?.authRequestID.state === 2 && <p>Cuenta verificada</p>}
                                </div>
                        }
                    </>
                }
                {
                    (userInfo.authRequestID && userInfo.authRequestID && userInfo.authRequestID.state === 2) && <>
                        {
                            !userInfo.franchiseID ?
                                <div
                                    onClick={() => {
                                        setIsShowMenu(!isShowMenu)
                                        history.push('/CreateFranchisee')
                                    }}
                                    className="text-navbar-navbar">

                                    Solicitar ser EcoTienda

                                </div> :
                                <div>
                                    {userInfo?.franchiseID?.state === 0 && <p>Pendiente de verificación</p>}
                                    {userInfo?.franchiseID?.state === 1 && (
                                        <div
                                            onClick={() => {
                                                setIsShowMenu(!isShowMenu)
                                                history.push('/CreateFranchisee')
                                            }}
                                            className="text-navbar-navbar">

                                            Solicitar ser EcoTienda

                                        </div>
                                    )}
                                    {/* {userInfo?.franchiseID?.state === 2 && <div onClick={() => {
                                        setIsShowMenu(!isShowMenu)
                                        history.push(`/Profile/${localStorage.getItem("idUser")}`)
                                    }} 
                                    className="text-navbar-navbar">ver perfil de EcoTienda</div>} */}
                                </div>
                        }

                        {
                            userInfo?.franchiseID?.state != 2 &&
                            <>
                                {!userInfo?.representativeID ?
                                    <div
                                        onClick={() => {
                                            setIsShowMenu(!isShowMenu)
                                            history.push('/CreateRepresentative')
                                        }}
                                        className="text-navbar-navbar">

                                        Solicitar ser EcoMaster

                                    </div> :

                                    <div>
                                        {userInfo?.representativeID.state === 0 && <p>Solicitud de EcoMaster pendiente</p>}
                                        {userInfo?.representativeID.state === 1 && (
                                            <div
                                                onClick={() => {
                                                    setIsShowMenu(!isShowMenu)
                                                    history.push('/CreateRepresentative')
                                                }}
                                                className="text-navbar-navbar">

                                                Solicitar ser EcoMaster

                                            </div>
                                        )}
                                    </div>}
                            </>

                        }

                    </>


                }
                <div onClick={() => {
                    setIsShowMenu(!isShowMenu)
                    history.push('/UserPQRS')
                }} className="text-navbar-navbar">Peticiones, quejas, reclamos y sugerencias</div>



                <div className="title-navbar-menu">Herramientas</div>
                {
                    (userInfo?.authRequestID?.state === 2 || userInfo?.warehouseID) &&
                    <>
                        {
                            ((userInfo?.franchiseID || userInfo?.warehouseID) && localStorage().getItem("typeProfile") !== "user" ) ?
                                <div
                                    onClick={() => {
                                        setIsShowMenu(!isShowMenu)
                                        history.push('/OilMenu')
                                    }}
                                    className="text-navbar-navbar">

                                    Administrar aceite

                                </div> :

                                <div>

                                    <div onClick={() => {
                                        setIsShowMenu(!isShowMenu)
                                        history.push('/Oil/OilRecordEcoUser')
                                    }} className="text-navbar-navbar">
                                        Ver historial de aceite entregado
                                    </div>
                                    <div onClick={() => {
                                        setIsShowMenu(!isShowMenu)
                                        history.push('/Oil/OilRecordWarehouses')
                                    }} className="text-navbar-navbar">
                                        Encontrar un almacén donde entregar aceite
                                    </div>
                                </div>

                        }


                    </>
                }
                {
                    (userInfo?.franchiseID?.state === 2 || userInfo?.representativeID?.state === 2 || userInfo?.warehouseID) && (

                        <div onClick={() => {
                            setIsShowMenu(!isShowMenu)
                            dispatch(changeProfile(history))

                        }} className="text-navbar-navbar">Cambiar perfil</div>
                    )
                }

                <div className="content-logout-button">
                    <Logout
                        renderClose={<div onClick={() => {

                        }} >
                            <Button theme="white" text={Translate('closeSession', 'es')} />
                        </div>}
                    />
                </div>
            </div>
        </div>

    )
}

export default NavbarMenu
